!function (e) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else
    {
        var t;
        t = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, t.SGXSessionTracker = e()
    }
}(function () {
    return function e(t, n, i) {
        function o(r, c)
        {
            if (!n[r])
            {
                if (!t[r])
                {
                    var a = "function" == typeof require && require;
                    if (!c && a) return a(r, !0);
                    if (s) return s(r, !0);
                    var u = new Error("Cannot find module '" + r + "'");
                    throw u.code = "MODULE_NOT_FOUND", u
                }
                var l = n[r] = {exports: {}};
                t[r][0].call(l.exports, function (e) {
                    var n = t[r][1][e];
                    return o(n || e)
                }, l, l.exports, e, t, n, i)
            }
            return n[r].exports
        }

        for (var s = "function" == typeof require && require, r = 0; r < i.length; r++) o(i[r]);
        return o
    }({
        1: [
            function (e, t, n) {
                function i()
                {
                    this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0
                }

                function o(e)
                {
                    return "function" == typeof e
                }

                function s(e)
                {
                    return "number" == typeof e
                }

                function r(e)
                {
                    return "object" == typeof e && null !== e
                }

                function c(e)
                {
                    return void 0 === e
                }

                t.exports = i, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._maxListeners = void 0, i.defaultMaxListeners = 10, i.prototype.setMaxListeners = function (e) {
                    if (!s(e) || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
                    return this._maxListeners = e, this
                }, i.prototype.emit = function (e) {
                    var t, n, i, s, a, u;
                    if (this._events || (this._events = {}), "error" === e && (!this._events.error || r(this._events.error) && !this._events.error.length))
                    {
                        if ((t = arguments[1]) instanceof Error) throw t;
                        var l = new Error('Uncaught, unspecified "error" event. (' + t + ")");
                        throw l.context = t, l
                    }
                    if (n = this._events[e], c(n)) return !1;
                    if (o(n)) switch (arguments.length)
                    {
                        case 1:
                            n.call(this);
                            break;
                        case 2:
                            n.call(this, arguments[1]);
                            break;
                        case 3:
                            n.call(this, arguments[1], arguments[2]);
                            break;
                        default:
                            s = Array.prototype.slice.call(arguments, 1), n.apply(this, s)
                    } else if (r(n)) for (s = Array.prototype.slice.call(arguments, 1), u = n.slice(), i = u.length, a = 0; a < i; a++) u[a].apply(this, s);
                    return !0
                }, i.prototype.addListener = function (e, t) {
                    var n;
                    if (!o(t)) throw TypeError("listener must be a function");
                    return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e, o(t.listener) ? t.listener : t), this._events[e] ? r(this._events[e]) ? this._events[e].push(t) : this._events[e] = [
                        this._events[e], t
                    ] : this._events[e] = t, r(this._events[e]) && !this._events[e].warned && (n = c(this._maxListeners) ? i.defaultMaxListeners : this._maxListeners) && n > 0 && this._events[e].length > n && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), "function" == typeof console.trace && console.trace()), this
                }, i.prototype.on = i.prototype.addListener, i.prototype.once = function (e, t) {
                    function n()
                    {
                        this.removeListener(e, n), i || (i = !0, t.apply(this, arguments))
                    }

                    if (!o(t)) throw TypeError("listener must be a function");
                    var i = !1;
                    return n.listener = t, this.on(e, n), this
                }, i.prototype.removeListener = function (e, t) {
                    var n, i, s, c;
                    if (!o(t)) throw TypeError("listener must be a function");
                    if (!this._events || !this._events[e]) return this;
                    if (n = this._events[e], s = n.length, i = -1, n === t || o(n.listener) && n.listener === t) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, t); else if (r(n))
                    {
                        for (c = s; c-- > 0;) if (n[c] === t || n[c].listener && n[c].listener === t)
                        {
                            i = c;
                            break
                        }
                        if (i < 0) return this;
                        1 === n.length ? (n.length = 0, delete this._events[e]) : n.splice(i, 1), this._events.removeListener && this.emit("removeListener", e, t)
                    }
                    return this
                }, i.prototype.removeAllListeners = function (e) {
                    var t, n;
                    if (!this._events) return this;
                    if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e], this;
                    if (0 === arguments.length)
                    {
                        for (t in this._events) "removeListener" !== t && this.removeAllListeners(t);
                        return this.removeAllListeners("removeListener"), this._events = {}, this
                    }
                    if (n = this._events[e], o(n)) this.removeListener(e, n); else if (n) for (; n.length;) this.removeListener(e, n[n.length - 1]);
                    return delete this._events[e], this
                }, i.prototype.listeners = function (e) {
                    return this._events && this._events[e] ? o(this._events[e]) ? [this._events[e]] : this._events[e].slice() : []
                }, i.prototype.listenerCount = function (e) {
                    if (this._events)
                    {
                        var t = this._events[e];
                        if (o(t)) return 1;
                        if (t) return t.length
                    }
                    return 0
                }, i.listenerCount = function (e, t) {
                    return e.listenerCount(t)
                }
            }, {}
        ],
        2: [
            function (e, t, n) {
                "use strict";
                var i     = function (e, n) {
                    function i(e)
                    {
                        return e ? o(e) : void 0
                    }

                    function o(e)
                    {
                        for (var t in i.prototype) e[t] = i.prototype[t];
                        return e
                    }

                    void 0 !== t && (t.exports = i), i.prototype.on = i.prototype.addEventListener = function (e, t) {
                        return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this
                    }, i.prototype.once = function (e, t) {
                        function n()
                        {
                            this.off(e, n), t.apply(this, arguments)
                        }

                        return n.fn = t, this.on(e, n), this
                    }, i.prototype.off = i.prototype.removeListener = i.prototype.removeAllListeners = i.prototype.removeEventListener = function (e,
                                                                                                                                                   t) {
                        if (this._callbacks = this._callbacks || {}, 0 === arguments.length) return this._callbacks = {}, this;
                        var n = this._callbacks["$" + e];
                        if (!n) return this;
                        if (1 == arguments.length) return delete this._callbacks["$" + e], this;
                        for (var i, o = 0; o < n.length; o++) if ((i = n[o]) === t || i.fn === t)
                        {
                            n.splice(o, 1);
                            break
                        }
                        return this
                    }, i.prototype.emit = function (e) {
                        this._callbacks = this._callbacks || {};
                        var t           = [].slice.call(arguments, 1), n = this._callbacks["$" + e];
                        if (n)
                        {
                            n = n.slice(0);
                            for (var i = 0, o = n.length; o > i; ++i) n[i].apply(this, t)
                        }
                        return this
                    }, i.prototype.listeners = function (e) {
                        return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || []
                    }, i.prototype.hasListeners = function (e) {
                        return !!this.listeners(e).length
                    };
                    var s, r, c, a, u, l, f, h, d = function () {
                            var t, i = {};
                            return i.open = function () {
                                try
                                {
                                    var o;
                                    o = e.match("^https://") ? "wss" + e.substr(5) : "ws" + e.substr(4), o += n.baseURL + "ws", t = new WebSocket(o), t.onmessage = function (e) {
                                        i.onMessage(e.data.toString())
                                    }, t.onerror = function (e) {
                                        var t = "the websocket closed the connection with ";
                                        t += e.code ? "the error code: " + e.code : "an error.", i.onError(t)
                                    }, t.onclose = function () {
                                        i.onClose()
                                    }, t.onopen = function () {
                                        i.onOpen()
                                    }
                                }
                                catch (e)
                                {
                                    i.onError()
                                }
                            }, i.send = function (e) {
                                t.send(e)
                            }, i.reset = function () {
                                t && t.close(), t = void 0
                            }, i
                        }, p = function () {
                            var t, i, o, s = e + n.baseURL + "ajax", r = {
                                Timeout: "t",
                                Closed: "c"
                            }, c = {
                                Delimiter: "&",
                                Init: "i",
                                Push: "u",
                                Poll: "o"
                            }, a = {}, u = !1, l = !1, f = function () {
                                o = function () {
                                }, u && u.abort(), l && l.abort()
                            }, h = function (e, t, n, i, o) {
                                var s = window.XMLHttpRequest ? new XMLHttpRequest : new ActiveXObject("Microsoft.XMLHTTP");
                                return s.onload = function () {
                                    i(s.response)
                                }, s.onerror = function () {
                                    o()
                                }, s.ontimeout = function () {
                                    o("timeout")
                                }, s.open("POST", e, !0), s.responseType = "text", s.timeout = t, s.send(n), s
                            }, d = function () {
                                f(), a.onClose()
                            }, p = function (e) {
                                f(), e = e ? "the ajax socket closed the connection with the error: " + e : "the ajax socket closed the connection with an error.", a.onError(e)
                            }, v = function (e, t) {
                                l = h(s, 8e3, e, function (e) {
                                    l = !1, t && t(e)
                                }, function (e) {
                                    l = !1, p(e)
                                })
                            };
                            return o = function () {
                                u = h(s, 45e3, c.Poll + t + c.Delimiter + i, function (e) {
                                    if (u = !1, e == r.Timeout) return void o();
                                    if (e == r.Closed) return void d();
                                    var t = e.indexOf(c.Delimiter);
                                    return 0 > t ? void p("ajax socket: failed to split poll token from data!") : (i = e.substring(0, t), e = e.substr(t + 1), o(), void a.onMessage(e))
                                }, function (e) {
                                    u = !1, p(e)
                                })
                            }, a.open = function () {
                                v(c.Init, function (e) {
                                    var n = e.indexOf(c.Delimiter);
                                    return 0 > n ? void p("ajax socket: failed to split uid and poll token from data!") : (t = e.substring(0, n), i = e.substr(n + 1), o(), void a.onOpen())
                                })
                            }, a.send = function (e) {
                                v(c.Push + t + c.Delimiter + e)
                            }, a.reset = function () {
                                f()
                            }, a
                        }, v = "1.9.1", m = {
                            WebSocket: "WebSocket",
                            AjaxSocket: "AjaxSocket"
                        }, g = {
                            Len: 2,
                            Init: "in",
                            Ping: "pi",
                            Pong: "po",
                            Close: "cl",
                            Invalid: "iv",
                            DontAutoReconnect: "dr",
                            ChannelData: "cd"
                        }, _ = {
                            Disconnected: "disconnected",
                            Connecting: "connecting",
                            Reconnecting: "reconnecting",
                            Connected: "connected"
                        }, b = {
                            baseURL: "/glue/",
                            forceSocketType: !1,
                            connectTimeout: 1e4,
                            pingInterval: 35e3,
                            pingReconnectTimeout: 5e3,
                            reconnect: !0,
                            reconnectDelay: 1e3,
                            reconnectDelayMax: 5e3,
                            reconnectAttempts: 10,
                            resetSendBufferTimeout: 1e4
                        }, y = new i, k = !1, S = !1, L = _.Disconnected, w = 0, T = !1, x = !1, C = !1,
                        D = !1, M = [], O = !1, R = !1, j = !1, E = [], P = "", A = function () {
                            var e = {};
                            return e.extend = function () {
                                for (var e = 1; e < arguments.length; e++) for (var t in arguments[e]) arguments[e].hasOwnProperty(t) && (arguments[0][t] = arguments[e][t]);
                                return arguments[0]
                            }, e.isFunction = function (e) {
                                var t = {};
                                return e && "[object Function]" === t.toString.call(e)
                            }, e.unmarshalValues = function (e) {
                                if (!e) return !1;
                                var t = e.indexOf("&"), n = parseInt(e.substring(0, t), 10);
                                return e = e.substring(t + 1), !(0 > n || n > e.length) && {
                                    first: e.substr(0, n),
                                    second: e.substr(n)
                                }
                            }, e.marshalValues = function (e, t) {
                                return String(e.length) + "&" + e + t
                            }, e
                        }(), I = function () {
                            var e = {}, t = {}, n = function (e) {
                                var t = {
                                    onMessageFunc: function () {
                                    }
                                };
                                return t.instance = {
                                    onMessage: function (e) {
                                        t.onMessageFunc = e
                                    },
                                    send: function (t, n) {
                                        return t ? l(g.ChannelData, A.marshalValues(e, t), n) : -1
                                    }
                                }, t
                            };
                            return e.get = function (e) {
                                if (!e) return !1;
                                var i = t[e];
                                return i ? i.instance : (i = n(e), t[e] = i, i.instance)
                            }, e.emitOnMessage = function (e, n) {
                                if (e && n)
                                {
                                    var i = t[e];
                                    if (!i) return void console.log("glue: channel '" + e + "': emit onMessage event: channel does not exists");
                                    try
                                    {
                                        i.onMessageFunc(n)
                                    }
                                    catch (t)
                                    {
                                        return void console.log("glue: channel '" + e + "': onMessage event call failed: " + t.message)
                                    }
                                }
                            }, e
                        }();
                    u = function (e) {
                        return k ? j ? void k.send(e) : void E.push(e) : void 0
                    };
                    var F = function () {
                        if (0 !== E.length)
                        {
                            for (var e = 0; e < E.length; e++) u(E[e]);
                            E = []
                        }
                    }, U = function () {
                        R = !1, !1 !== O && (clearTimeout(O), O = !1)
                    }, q = function () {
                        !1 !== O || R || (O = setTimeout(function () {
                            if (O = !1, R = !0, 0 !== M.length)
                            {
                                for (var e, t = 0; t < M.length; t++) if (e = M[t], e.discardCallback && A.isFunction(e.discardCallback)) try
                                {
                                    e.discardCallback(e.data)
                                }
                                catch (e)
                                {
                                    console.log("glue: failed to call discard callback: " + e.message)
                                }
                                h("discard_send_buffer"), M = []
                            }
                        }, n.resetSendBufferTimeout))
                    }, N = function () {
                        if (U(), 0 !== M.length)
                        {
                            for (var e, t = 0; t < M.length; t++) e = M[t], u(e.cmd + e.data);
                            M = []
                        }
                    };
                    l = function (e, t, n) {
                        return t || (t = ""), k && L === _.Connected ? (u(e + t), 1) : R ? (n && A.isFunction(n) && n(t), -1) : (q(), M.push({
                            cmd            : e,
                            data           : t,
                            discardCallback: n
                        }), 0)
                    };
                    var W = function () {
                        !1 !== x && (clearTimeout(x), x = !1)
                    }, $ = function () {
                        W(), x = setTimeout(function () {
                            x = !1, h("connect_timeout"), f()
                        }, n.connectTimeout)
                    }, X = function () {
                        !1 !== C && (clearTimeout(C), C = !1), !1 !== D && (clearTimeout(D), D = !1)
                    }, J = function () {
                        X(), C = setTimeout(function () {
                            C = !1, u(g.Ping), D = setTimeout(function () {
                                D = !1, h("timeout"), f()
                            }, n.pingReconnectTimeout)
                        }, n.pingInterval)
                    }, V = function () {
                        return S ? void (k = r()) : w > 1 ? (r = p, k = r(), void (c = m.AjaxSocket)) : (!n.forceSocketType && window.WebSocket || n.forceSocketType === m.WebSocket ? (r = d, c = m.WebSocket) : (r = p, c = m.AjaxSocket), void (k = r()))
                    }, B = function (e) {
                        return e = JSON.parse(e), e.socketID ? (P = e.socketID, j = !0, F(), L = _.Connected, h("connected"), void setTimeout(N, 0)) : (a(), void console.log("glue: socket initialization failed: invalid initialization data received"))
                    }, H = function () {
                        V(), k.onOpen = function () {
                            W(), w = 0, S = !0, J();
                            var e = {version: v};
                            e = JSON.stringify(e), k.send(g.Init + e)
                        }, k.onClose = function () {
                            f()
                        }, k.onError = function (e) {
                            h("error", [e]), f()
                        }, k.onMessage = function (e) {
                            if (J(), e.length < g.Len) return void console.log("glue: received invalid data from server: data is too short.");
                            var t = e.substr(0, g.Len);
                            if (e = e.substr(g.Len), t === g.Ping) u(g.Pong); else if (t === g.Pong) ; else if (t === g.Invalid) console.log("glue: server replied with an invalid request notification!"); else if (t === g.DontAutoReconnect) T = !0, console.log("glue: server replied with an don't automatically reconnect request. This might be due to an incompatible protocol version."); else if (t === g.Init) B(e); else if (t === g.ChannelData)
                            {
                                var n = A.unmarshalValues(e);
                                if (!n) return void console.log("glue: server requested an invalid channel data request: " + e);
                                I.emitOnMessage(n.first, n.second)
                            }
                            else console.log("glue: received invalid data from server with command '" + t + "' and data '" + e + "'!")
                        }, setTimeout(function () {
                            w > 0 ? (L = _.Reconnecting, h("reconnecting")) : (L = _.Connecting, h("connecting")), $(), k.open()
                        }, 0)
                    }, z = function () {
                        W(), X(), j = !1, P = "", E = [], k && (k.onOpen = k.onClose = k.onMessage = k.onError = function () {
                        }, k.reset(), k = !1)
                    };
                    if (f = function () {
                        if (z(), n.reconnectAttempts > 0 && w >= n.reconnectAttempts || !1 === n.reconnect || T) return L = _.Disconnected, void h("disconnected");
                        w += 1;
                        var e = n.reconnectDelay * w;
                        e > n.reconnectDelayMax && (e = n.reconnectDelayMax), setTimeout(function () {
                            H()
                        }, e)
                    }, a = function () {
                        k && (u(g.Close), z(), L = _.Disconnected, h("disconnected"))
                    }, s = I.get("m"), e || (e = window.location.protocol + "//" + window.location.host), !e.match("^http://") && !e.match("^https://")) return void console.log("glue: invalid host: missing 'http://' or 'https://'!");
                    n = A.extend({}, b, n), n.reconnectDelayMax < n.reconnectDelay && (n.reconnectDelayMax = n.reconnectDelay), 0 !== n.baseURL.indexOf("/") && (n.baseURL = "/" + n.baseURL), "/" !== n.baseURL.slice(-1) && (n.baseURL = n.baseURL + "/"), H();
                    var G = {
                        version  : function () {
                            return v
                        },
                        type     : function () {
                            return c
                        },
                        state    : function () {
                            return L
                        },
                        socketID : function () {
                            return P
                        },
                        send     : function (e, t) {
                            s.send(e, t)
                        },
                        onMessage: function (e) {
                            s.onMessage(e)
                        },
                        on       : function () {
                            y.on.apply(y, arguments)
                        },
                        reconnect: function () {
                            L === _.Disconnected && (w = 0, T = !1, f())
                        },
                        close    : function () {
                            a()
                        },
                        channel  : function (e) {
                            return I.get(e)
                        }
                    };
                    return h = function () {
                        y.emit.apply(y, arguments)
                    }, G
                };
                t.exports = i
            }, {}
        ],
        3: [
            function (e, t, n) {
                "use strict";
                t.exports = e("./sgxsessiontracker.js").default
            }, {"./sgxsessiontracker.js": 4}
        ],
        4: [
            function (e, t, n) {
                "use strict";

                function i(e)
                {
                    return e && e.__esModule ? e : {default: e}
                }

                function o(e, t)
                {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }

                function s(e, t)
                {
                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !t || "object" != typeof t && "function" != typeof t ? e : t
                }

                function r(e, t)
                {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value       : e,
                            enumerable  : !1,
                            writable    : !0,
                            configurable: !0
                        }
                    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                }

                Object.defineProperty(n, "__esModule", {value: !0});
                var c     = function () {
                    function e(e, t)
                    {
                        for (var n = 0; n < t.length; n++)
                        {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }

                    return function (t, n, i) {
                        return n && e(t.prototype, n), i && e(t, i), t
                    }
                }(), a    = e("events"), u = i(a), l = e("./glue"), f = i(l), h = function (e) {
                    function t(e)
                    {
                        o(this, t);
                        var n = s(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                        return n.options = e, n.options.reconnect_attempts = n.reconnect_attempts = n.options.reconnect_attempts || 0, n.connected = !1, n.session_running = !1, n
                    }

                    return r(t, e), c(t, [
                        {
                            key  : "run",
                            value: function () {
                                this.socket = (0, f.default)((this.options.ssl ? "https://" : "http://") + this.options.server.replace(/(^\w+:|^)\/\//, ""), {
                                    baseURL               : "/glue/",
                                    connectTimeout        : 1e4,
                                    pingInterval          : 5e3,
                                    pingReconnectTimeout  : 5e3,
                                    reconnect             : this.options.reconnect_attempts > 0,
                                    reconnectDelay        : 1e3,
                                    reconnectDelayMax     : 5e3,
                                    reconnectAttempts     : this.options.reconnect_attempts,
                                    resetSendBufferTimeout: 1e4,
                                    forceSocketType       : this.options.socket_type || !1
                                }), this.socket.on("connected", this.onConnected.bind(this)), this.socket.on("error", this.onConnectFailed.bind(this)), this.socket.on("connect_timeout", this.onConnectFailed.bind(this)), this.socket.on("reconnecting", this.onReconnecting.bind(this)), this.socket.on("disconnected", this.onDisconnected.bind(this)), this.socket.onMessage(this.onSessionState.bind(this)), this.emit("debug", "connecting to " + this.options.server)
                            }
                        }, {
                            key  : "onConnected",
                            value: function () {
                                this.connected = !0, this.reconnect_attempts = this.options.reconnect_attempts, this.emit("debug", "connected to " + this.options.server);
                                var e = JSON.stringify({session_id: this.options.session_id});
                                this.socket.send(e), this.emit("debug", "track_session " + e), this.emit("connected")
                            }
                        }, {
                            key  : "onConnectFailed",
                            value: function () {
                                this.emit("debug", "connect_failed [" + this.reconnect_attempts + "]"), this.emit("connection_failed", this.reconnect_attempts)
                            }
                        }, {
                            key  : "onConnectTimeout",
                            value: function () {
                                this.emit("debug", "connect_timeout"), this.emit("connection_failed")
                            }
                        }, {
                            key  : "onReconnecting",
                            value: function () {
                                this.emit("debug", "reconnecting"), this.reconnect_attempts--
                            }
                        }, {
                            key  : "onSessionState",
                            value: function (e) {
                                this.emit("debug", "session_state " + e);
                                var n = JSON.parse(e);
                                switch (n.state)
                                {
                                    case t.States.SessionNotFound:
                                        this.emit("session_not_found");
                                        break;
                                    case t.States.SessionPending:
                                        this.emit("session_pending");
                                        break;
                                    case t.States.SessionStarted:
                                        this.emit("session_started");
                                        break;
                                    case t.States.SessionFailedToStart:
                                        this.emit("session_failed_to_start");
                                        break;
                                    case t.States.SessionCrashed:
                                        this.emit("session_crashed");
                                        break;
                                    case t.States.SessionConnectTimeout:
                                        this.emit("session_connect_timeout");
                                        break;
                                    case t.States.SessionInactiveTimeout:
                                        this.emit("session_inactive_timeout");
                                        break;
                                    case t.States.SessionDurationLimitReached:
                                        this.emit("session_duration_limit_reached");
                                        break;
                                    case t.States.SessionReconnectTimeout:
                                        this.emit("session_reconnect_timeout");
                                        break;
                                    case t.States.SessionTerminated:
                                        this.emit("session_terminated");
                                        break;
                                    case t.States.SessionConnectionLost:
                                        this.emit("session_connection_lost")
                                }
                                this.emit("session_response", n), n.state !== t.States.SessionPending && n.state !== t.States.SessionStarted ? (this.session_running = !1, this.socket.close()) : this.session_running = !0
                            }
                        }, {
                            key  : "onDisconnected",
                            value: function () {
                                this.session_running ? (this.emit("debug", "connection_lost"), this.emit("connection_lost")) : this.emit("debug", "disconnected"), this.socket.close()
                            }
                        }, {
                            key  : "terminate",
                            value: function () {
                                this.socket.close()
                            }
                        }
                    ], [
                        {
                            key: "States",
                            get: function () {
                                return {
                                    SessionNotFound            : -1,
                                    SessionPending             : 0,
                                    SessionStarted             : 1,
                                    SessionFailedToStart       : 2,
                                    SessionCrashed             : 3,
                                    SessionConnectTimeout      : 4,
                                    SessionInactiveTimeout     : 5,
                                    SessionDurationLimitReached: 6,
                                    SessionReconnectTimeout    : 7,
                                    SessionTerminated          : 8,
                                    SessionConnectionLost      : 9
                                }
                            }
                        }
                    ]), t
                }(u.default);
                n.default = h
            }, {
                "./glue": 2,
                events  : 1
            }
        ]
    }, {}, [3])(3)
});
